import {
  Switch,
  BrowserRouter,
  Route,
  RouteProps,
  Redirect,
} from 'react-router-dom';
import Layout from './components/layout/common.layout';
import Home from './view/home';
import Join from './view/auth/join/join';
import JoinSelect from './view/auth/join/joinSel';
import JoinCompany from './view/auth/join/joinCompany';
import JoinComplate from './view/auth/join/joinComplate';
import ForgotAccount from './view/auth/forgot/forgotAccount';
import UserHome from './view/user/home/user.home';
import UserDefaultCostSetting from './view/user/mypage/user.mypage.default.cost';
import UserDelegationChange from './view/user/mypage/user.mypage.delegation.change';
import UserContract from './view/user/contract/user.contract';
import UserOrder from './view/user/order/user.order';
import ContractDetail from './view/common/common.contract.detail';
import OrderDetail from './view/common/common.order.detail';
import UserDiary from './view/user/dairy/user.dairy';
import UserDairyTransactionStatementRegist from './view/user/dairy/user.dairy.transaction.statement.regist';
import UserFavorComp from './view/user/favor/user.favor.comp';
import ManagerHome from './view/manager/manager.home';
import DefaultCostSetting from './view/manager/mypage/manager.mypage.default.cost';
import ManagerInfoChange from './view/manager/mypage/manager.mypage.information.change';
import ManagerOrder from './view/manager/order/manager.order';
import OrderRegist from './view/manager/order/manager.order.regist';
import OrderStatus from './view/manager/order/manager.order.status';
import OrderStatusAlert from './view/manager/order/manager.order.alert';
import Mypage from './view/common/common.mypage';
import PasswordChange from './view/common/common.password.change';
import CarRegistrationChange from './view/common/common.car.registration.change';
import Inquiry from './view/common/inquiry/common.inquiry';
import InquiryRegist from './view/common/inquiry/common.inquiry.regist';
import InquiryDetail from './view/common/inquiry/common.inquiry.detail';
import Notice from './view/common/notice/common.notice';
import NoticeDetail from './view/common/notice/common.notice.detail';
import CommonJobSearch from './view/common/job/common.job.search';
import CommonJobSearchRegist from './view/common/job/common.job.search.regist';
import CommonJobSearchDetail from './view/common/job/common.job.search.detail';
import CommonAlert from './view/common/common.alert';
import PrivateRoute from './private.router';
import NotFound from './view/error/error.404';
import PhoneChange from './view/common/common.phone.change';
import OrderUpdate from './view/manager/order/manager.order.update';
import InquiryUpdate from './view/common/inquiry/common.inquiry.update';
import CommonJobSearchUpdate from './view/common/job/common.job.search.update';
import UserFavorCompList from './view/user/favor/user.favor.comp.list';
import UserDiaryRentRegist from './view/user/dairy/user.dairy.rent.regist';
import UserDairyRentDetail from './view/user/dairy/user.dairy.rent.detail';
import UserDiaryBelongedRegist from './view/user/dairy/user.dairy.belonged.regist';
import UserDairyBelongedDetail from './view/user/dairy/user.dairy.belonged.detail';
import UserDiaryBelongedUpdate from './view/user/dairy/user.dairy.belonged.update';
import UserDiaryRentUpdate from './view/user/dairy/user.dairy.rent.update';
import AdminPrivateRoute from './admin.private.router';
import AdminLogin from './view/admin/admin.login';
import AdminLayout from './components/layout/admin/admin.layout';
import AdminInquiryList from './view/admin/inquiry/admin.inquiry.list';
import AdminNoticeList from './view/admin/notice/admin.notice.list';
import AdminCorporationList from './view/admin/corporation/admin.corporation.list';
import AdminMemberList from './view/admin/member/admin.member.list';
import AdminMemberDetail from './view/admin/member/admin.member.detail';
import AdminInquiryDetail from './view/admin/inquiry/admin.inquiry.detail';
import AdminNoticeRegist from './view/admin/notice/admin.notice.regist';
import AdminNoticeUpdate from './view/admin/notice/admin.notice.update';
import AdminCorporationRegist from './view/admin/corporation/admin.corporation.regist';
import AdminCorporationUpdate from './view/admin/corporation/admin.corporation.update';

interface RouteWrapperProps extends RouteProps {
  component: React.ComponentType<any>;
  layout: React.ComponentType<any>;
  menuTitle?: string;
  whiteBgColor?: boolean;
  isFooter?: boolean;
  showBackArrow?: boolean;
}

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/privacy/privacy_form.html"
          exact
          render={() => {
            window.location.href = "/privacy/privacy_form.html";
            return null;
          }}
        />
        <RouteWrapper
          path="/joinSelect"
          exact
          component={JoinSelect}
          layout={Layout}
          menuTitle="회원 가입"
          whiteBgColor
        />
        <RouteWrapper
          path="/join"
          exact
          component={Join}
          layout={Layout}
          menuTitle="회원 가입"
          whiteBgColor
        />
        <RouteWrapper
          path="/joinCompany"
          exact
          component={JoinCompany}
          layout={Layout}
          menuTitle="회원 가입"
          whiteBgColor
        />
        <RouteWrapper
          path="/joinComplate"
          exact
          component={JoinComplate}
          layout={Layout}
          menuTitle="회원 가입"
          whiteBgColor
        />
        <RouteWrapper
          path="/login"
          exact
          component={Home}
          layout={Layout}
          whiteBgColor
        />
        <RouteWrapper
          path="/forgotAccount"
          exact
          component={ForgotAccount}
          layout={Layout}
          menuTitle="아이디 / 비밀번호 찾기"
          whiteBgColor
        />
        {/* common */}
        <PrivateRoute
          path="/mypage"
          exact
          component={Mypage}
          layout={Layout}
          menuTitle="마이 페이지"
          isFooter
          showBackArrow
        />
        <PrivateRoute
          path="/mypage/passowrdChange"
          exact
          component={PasswordChange}
          layout={Layout}
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/mypage/phoneChange"
          exact
          component={PhoneChange}
          layout={Layout}
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/mypage/carRegistrationChange"
          exact
          component={CarRegistrationChange}
          layout={Layout}
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/inquiry"
          exact
          component={Inquiry}
          layout={Layout}
          menuTitle="1:1 문의"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/inquiry/regist"
          exact
          component={InquiryRegist}
          layout={Layout}
          menuTitle="1:1 문의"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/inquiry/update/:id"
          exact
          component={InquiryUpdate}
          layout={Layout}
          menuTitle="1:1 문의"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/inquiry/detail/:id"
          exact
          component={InquiryDetail}
          layout={Layout}
          menuTitle="1:1 문의"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/notice"
          exact
          component={Notice}
          layout={Layout}
          menuTitle="공지사항"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/notice/detail/:id"
          exact
          component={NoticeDetail}
          layout={Layout}
          menuTitle="공지사항"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/working"
          exact
          component={CommonJobSearch}
          layout={Layout}
          menuTitle="일감 구함"
          isFooter
        />
        <PrivateRoute
          path="/working/regist"
          exact
          component={CommonJobSearchRegist}
          layout={Layout}
          menuTitle="일감 구함 등록"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/working/detail/:id"
          exact
          component={CommonJobSearchDetail}
          layout={Layout}
          menuTitle="일감 구함 상세"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/working/update/:id"
          exact
          component={CommonJobSearchUpdate}
          layout={Layout}
          menuTitle="일감 구함 수정"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/common/alert"
          exact
          component={CommonAlert}
          layout={Layout}
          menuTitle="알림"
          whiteBgColor
          showBackArrow
        />
        {/* user layout */}
        <PrivateRoute
          path="/userHome"
          exact
          component={UserHome}
          layout={Layout}
          isFooter
          menuTitle="마이홈"
        />
        <PrivateRoute
          path="/mypage/user/defaultCostSetting"
          exact
          component={UserDefaultCostSetting}
          layout={Layout}
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/mypage/user/delegationChange"
          exact
          component={UserDelegationChange}
          layout={Layout}
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userContract"
          exact
          component={UserContract}
          layout={Layout}
          menuTitle="수주내역"
          isFooter
        />
        <PrivateRoute
          path="/contract/detail/:id"
          exact
          component={ContractDetail}
          layout={Layout}
          menuTitle="수주 상세 정보"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userOrder"
          exact
          component={UserOrder}
          layout={Layout}
          menuTitle="발주정보"
          isFooter
        />
        <PrivateRoute
          path="/order/detail/:id"
          exact
          component={OrderDetail}
          layout={Layout}
          menuTitle="발주 상세 정보"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userDiary"
          exact
          component={UserDiary}
          layout={Layout}
          menuTitle="일보정리"
          isFooter
        />
        <PrivateRoute
          path="/userDiary/belonged/regist"
          exact
          component={UserDiaryBelongedRegist}
          layout={Layout}
          menuTitle="일보정리 -"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userDiary/rent/regist"
          exact
          component={UserDiaryRentRegist}
          layout={Layout}
          menuTitle="일보정리 -"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userDiary/belonged/update/:id"
          exact
          component={UserDiaryBelongedUpdate}
          layout={Layout}
          menuTitle="일보 정리 수정 - 일대차"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userDiary/rent/update/:id"
          exact
          component={UserDiaryRentUpdate}
          layout={Layout}
          menuTitle="일보 정리 수정 - 마당차"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userDiary/belonged/detail/:id"
          exact
          component={UserDairyBelongedDetail}
          layout={Layout}
          menuTitle="상세정보 -"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userDiary/rent/detail/:id"
          exact
          component={UserDairyRentDetail}
          layout={Layout}
          menuTitle="상세정보 -"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/userDiary/transactionSatementRegist"
          exact
          component={UserDairyTransactionStatementRegist}
          layout={Layout}
          menuTitle="거래명세표 -"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/user/favor/company"
          exact
          component={UserFavorComp}
          layout={Layout}
          menuTitle="선호 회사 설정"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/user/favor/company/list"
          exact
          component={UserFavorCompList}
          layout={Layout}
          menuTitle="선호 회사 목록"
          whiteBgColor
          showBackArrow
        />
        {/* manager layout */}
        <PrivateRoute
          path="/managerHome"
          exact
          component={ManagerHome}
          layout={Layout}
          menuTitle="마이홈"
          isFooter
        />
        <PrivateRoute
          path="/mypage/manager/defaultCostSetting"
          exact
          component={DefaultCostSetting}
          layout={Layout}
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/mypage/manager/informationChange"
          exact
          component={ManagerInfoChange}
          layout={Layout}
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/managerOrder"
          exact
          component={ManagerOrder}
          layout={Layout}
          menuTitle="발주정보"
          isFooter
        />
        <PrivateRoute
          path="/managerOrder/regist"
          exact
          component={OrderRegist}
          layout={Layout}
          menuTitle="발주 등록"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/manager/order/status"
          exact
          component={OrderStatus}
          layout={Layout}
          menuTitle="수주 현황"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/managerOrder/update/:id"
          exact
          component={OrderUpdate}
          layout={Layout}
          menuTitle="발주 수정"
          whiteBgColor
          showBackArrow
        />
        <PrivateRoute
          path="/manager/order/status/alert"
          exact
          component={OrderStatusAlert}
          layout={Layout}
          whiteBgColor
          showBackArrow
        />
        {/* admin */}
        <RouteWrapper
          path="/admin/login"
          exact
          component={AdminLogin}
          layout={AdminLayout}
          whiteBgColor
        />
        <AdminPrivateRoute
          path="/admin/member/list"
          exact
          component={AdminMemberList}
          layout={AdminLayout}
          menuTitle="회원 리스트"
        />
        <AdminPrivateRoute
          path="/admin/member/list/detail/:id"
          exact
          component={AdminMemberDetail}
          layout={AdminLayout}
          menuTitle="회원 리스트"
        />
        <AdminPrivateRoute
          path="/admin/inquiry/list"
          exact
          component={AdminInquiryList}
          layout={AdminLayout}
          menuTitle="1:1 문의"
        />
        <AdminPrivateRoute
          path="/admin/inquiry/list/detail/:id"
          exact
          component={AdminInquiryDetail}
          layout={AdminLayout}
          menuTitle="1:1 문의"
        />
        <AdminPrivateRoute
          path="/admin/notice/list"
          exact
          component={AdminNoticeList}
          layout={AdminLayout}
          menuTitle="공지사항"
        />
        <AdminPrivateRoute
          path="/admin/notice/regist"
          exact
          component={AdminNoticeRegist}
          layout={AdminLayout}
          menuTitle="공지사항"
        />
        <AdminPrivateRoute
          path="/admin/notice/update/:id"
          exact
          component={AdminNoticeUpdate}
          layout={AdminLayout}
          menuTitle="공지사항"
        />
        <AdminPrivateRoute
          path="/admin/corporation/list"
          exact
          component={AdminCorporationList}
          layout={AdminLayout}
          menuTitle="회사 리스트"
        />
        <AdminPrivateRoute
          path="/admin/corporation/regist"
          exact
          component={AdminCorporationRegist}
          layout={AdminLayout}
          menuTitle="회사 리스트"
        />
        <AdminPrivateRoute
          path="/admin/corporation/update/:id"
          exact
          component={AdminCorporationUpdate}
          layout={AdminLayout}
          menuTitle="회사 리스트"
        />
        <Route path="/404" component={NotFound} />
        <Redirect from="/" to="/login" />
        <Route path="*" component={NotFound} />{' '}
        {/* 잘못된 경로는 모두 404로 리다이렉트 */}
      </Switch>
    </BrowserRouter>
  );
};

const RouteWrapper = ({
  component: Component,
  layout: Layout,
  menuTitle,
  whiteBgColor,
  isFooter,
  showBackArrow,
  ...rest
}: RouteWrapperProps) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout
          menuTitle={menuTitle}
          whiteBgColor={whiteBgColor}
          isFooter={isFooter}
          showBackArrow={showBackArrow}
        >
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default Router;
